<template>
  <div class="order-index">
<!--      工单-->
    <transition name="fade-transform" mode="out-in">
    <router-view/>
    </transition>
  </div>
</template>

<script>
  export default {
    name: 'order-index',
    data() {
      return {

      }
    },
    mounted() {

    },
    methods: {

    }
  }
</script>

<style lang="scss">
	@import './css/order.scss'
</style>
